import { i18nFilter } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter, numberFilter, percentageFilter, suffixFilter } from "app/filters/ngFilters";
import type * as React from "react";
import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import type { ReactNode } from "react";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const TotalItem = styled(CenteredFlexRow)`
    height: 41px;
    flex-grow: 1;
    text-transform: capitalize;
    padding-left: 15px;
    border-right: 1px solid ${colorsPalettes.carbon[50]};

    &:last-of-type {
        border-right: 0;
    }
`;

const Text = styled.span`
    ${mixins.setFont({ $size: 14, $color: rgba(colorsPalettes.carbon[500], 0.8) })};
    max-width: 90px;
    margin-left: 8px;
    line-height: 19px;
`;

const Number = styled.span`
    margin-right: 4px;
    ${mixins.setFont({ $size: 32, $color: colorsPalettes.carbon[500], $weight: 300 })};
`;

export const PublishersOverview = ({ totalVisits, totalShare, totalUnGroupedCount }) => {
    const items = [
        {
            value: minVisitsAbbrFilter()(totalVisits),
            text: i18nFilter()("analysis.common.trafficsource.ad.advisits"),
        },
        {
            value: suffixFilter()(percentageFilter()(totalShare, 2), "%"),
            text: `${i18nFilter()("shared.totals.total")} ${i18nFilter()(
                "analysis.common.trafficsource.ad.adstraffic",
            )}`,
        },
        {
            value: numberFilter()(totalUnGroupedCount),
            text: i18nFilter()("analysis.common.trafficsource.ad.addomains"),
        },
    ];
    return <CommonTableOverview items={items} />;
};

export const CommonTableOverview: React.FC<{
    items: Array<{ value: ReactNode; text: ReactNode }>;
}> = ({ items = [] }) => {
    return (
        <>
            {items.map(({ text, value }, index) => {
                return (
                    <TotalItem key={`item-${index}`}>
                        <Number>{value}</Number>
                        <Text>{text}</Text>
                    </TotalItem>
                );
            })}
        </>
    );
};
